import app from '$$app';
import routerHelper from '$$routerHelper';
import getSvgIcon from '../../helpers/getSvgIcon';
import { getBlockedItemsByRights } from './helpers';
import Tasks from '../../controllers/tasks';
import colorHelper from '$$helpers/color';
import constants from '$$helpers/constants';
import CopyPaste from '../../controllers/copyPaste';
import InlineEditors from '../../controllers/inlineEditors';

class WebixContextMenu {
  #instance;

  #taskId;

  #isTemplateLoaded = false;

  #contextMenuList;

  #contextMenuPopup;

  #contextMenuItemsConfig = [
    {
      id: 'edit_task',
      css: 'context_menu_list_border_bottom',
      icon: getSvgIcon('open', 'regular', 24),
      // handler: () => this.#openEditTaskPopup(),
    },
    {
      id: 'edit_milestone',
      css: 'context_menu_list_border_bottom',
      icon: getSvgIcon('open', 'regular', 24),
      // handler: () => this.#openEditTaskPopup(),
    },
    {
      id: 'separatorBefore',
      $template: 'Separator',
    },
    {
      id: 'go_to_project',
      icon: getSvgIcon('link-2', 'regular', 24),
      // handler: () => this.#goToProject(),
    },
    {
      id: 'add_subtask',
      icon: getSvgIcon('add-task-1', 'color-regular', 24),
      // handler: () => this.#addTaskCommonHandler(),
    },
    {
      id: 'add_sibling_task',
      icon: getSvgIcon('paste-3', 'color-regular', 24),
      handler: () => {},
      // handler: innerHandlers.addTaskCommonHandler,
    },
    // {
    //   id: 'add_child_milestone',
    //   icon: getSvgIcon('add-milestone-1', 'color-regular', 24),
    //   handler: innerHandlers.addTaskCommonHandler,
    // },
    {
      id: 'add_sibling_milestone',
      icon: getSvgIcon('add-milestone-2', 'color-regular', 24),
      handler: () => {},
      // handler: innerHandlers.addTaskCommonHandler,
    },
    {
      id: 'move_indent',
      icon: getSvgIcon('add-task-3', 'color-regular', 24),
      handler: () => {},
      // handler: innerHandlers.addTaskCommonHandler,
    },
    {
      id: 'move_outdent',
      icon: getSvgIcon('add-task-4', 'color-regular', 24),
      handler: () => {},
      // handler: innerHandlers.addTaskCommonHandler,
    },
    {
      id: 'convert_in_milestone',
      icon: getSvgIcon('milestone', 'regular', 24),
      handler: () => {},
      // handler: innerHandlers.convertTaskHandler,
    },
    {
      id: 'separatorAfter',
      $template: 'Separator',
    },
    {
      id: 'convert_in_task',
      icon: getSvgIcon('task', 'regular', 24),
      handler: () => {},
      // handler: innerHandlers.convertTaskHandler,
    },
    {
      id: 'copy_task',
      css: 'context_menu_list_border_top',
      icon: getSvgIcon('copy', 'regular', 24),
      handler: () => {},
      // handler: innerHandlers.copyTask,
    },
    {
      id: 'paste_task',
      icon: getSvgIcon('paste', 'regular', 24),
      css: 'context_menu_list_right_arrow',
      submenu: [
        {
          id: 'paste_task_above',
          icon: getSvgIcon('paste-2', 'color-regular', 24),
          // css: "context_menu_list_border_bottom",
          handler: () => {},
          // handler: innerHandlers.pasteTask,
        },
        {
          id: 'paste_task_below',
          icon: getSvgIcon('paste-1', 'color-regular', 24),
          handler: () => {},
          // handler: innerHandlers.pasteTask,
        },
      ],
    },
    {
      id: 'paste_task_disabled',
      icon: getSvgIcon('paste', 'regular', 24),
      disabled: true,
      css: 'context_menu_list_disable',
    },
    {
      id: 'copy_paste_settings',
      icon: getSvgIcon('settings', 'regular', 24),
      handler: () => {},
    },
    {
      id: 'separatorAfterCopyPaste',
      $template: 'Separator',
    },
    {
      id: 'select_task_for_masschange',
      icon: getSvgIcon('checkbox-filled', 'regular', 24),
      handler: () => {},
      // handler: innerHandlers.enableMassChange,
    },
    {
      id: 'choose_task_color',
      css: 'context_menu_list_border_bottom context_menu_list_right_arrow',
      icon: getSvgIcon('color-backgroud', 'regular', 24),
      mouseMoveHandler: node => this.#showColorBoard(node),
    },
    {
      id: 'delete_task',
      css: 'context_menu_list_red',
      icon: getSvgIcon('delete', 'regular', 24),
      handler: () => {},
      // handler: innerHandlers.removeTaskHandler,
      // listViewHandler: innerHandlers.removeTaskListView,
    },
    {
      id: 'choose_project_color',
      css: 'context_menu_list_border_bottom context_menu_list_right_arrow',
      icon: getSvgIcon('color-backgroud', 'regular', 24),
      mouseMoveHandler: node => this.#showColorBoard(node),
    },
  ];

  init(instance) {
    this.#instance = instance;

    if (!this.#isTemplateLoaded) {
      loadWebixTemplates();
      this.#isTemplateLoaded = true;
    }

    this.#contextMenuList = $$(innerViews.contextMenuList.id);
    this.#contextMenuPopup = $$(innerViews.main.id);
    this.#attachColorBoardEvents();
  }

  show(config) {
    const { taskId, anchorNode, anchorPosition } = config;

    app.trigger('gantt:contextMenu:showed', +taskId, this.#instance.getTask(+taskId).gantt_id);

    this.#taskId = taskId;

    const menuItems = this.#prepareMenuItems();

    if (!menuItems.length) {
      return;
    }

    const nodes = document.querySelectorAll('.column-options-cog');

    _.each(nodes, node => {
      node && node.classList.remove('active');
    });

    if (anchorPosition) {
      const coordY = anchorPosition.y;
      const docHeight = document.body.clientHeight;
      const popupHeight = this.#contextMenuPopup.$height;

      if ((coordY + popupHeight + 30) > docHeight) {
        anchorPosition.y = Math.max(anchorPosition.y - popupHeight - 30, 0);
      }

      this.#contextMenuPopup.show(anchorPosition);
      userExtAnalytics.log('gantt_context_menu_show_open', { from: 'right click' });
    } else {
      this.#contextMenuPopup.show(this.#calculatePopupCoordinatesFromNode(anchorNode));
      userExtAnalytics.log('gantt_context_menu_show_open', { from: 'button' });
    }

    anchorNode && anchorNode.classList.add('active');

    this.#setMenuItemTaskColor(this.#taskId);

    // const menuItems = $$contextMenuList.serialize();

    // if (menuItems.length) {
    //   innerHandlers.changeMenuIconForTaskColor($$contextMenuList, taskId);
    //
    //   innerHandlers.showContextMenuPopup(config, taskId);
    //   app.trigger('gantt:contextMenu:showed', +taskId);
    // }
  }

  hide(needDelay) {
    if (this.#contextMenuPopup.isVisible()) {
      this.#taskId = null;

      if (needDelay) {
        webix.delay(() => {
          this.#contextMenuPopup.hide();
        });
      } else {
        this.#contextMenuPopup.hide();
      }
    }
  }

  onMouseDown(event) {
    if (this.#contextMenuPopup?.isVisible() && !event.target.closest('.context_menu_popup') && !event.target.closest('.grid-colorboard-popup') && !event.target.closest('.context_menu_submenu')) {
      this.hide();
    }
  }

  onTaskClick(taskId, event) {
    const anchorNode = event.target.closest('.column-options');

    if (anchorNode) {
      this.show({ taskId, anchorNode, anchorPosition: null });
    }
  }

  onContextMenu(taskId, linkId, event) {
    if (!taskId) {
      return false;
    }

    const anchorNode = event.target || event.srcElement;

    const canShowContextMenu = [
      !this.#instance.ganttDataApi.isMassChangeEnabled(),
      !routerHelper.isTaskSettingsRoute(),
      !this.#isTaskRow(anchorNode),
      taskId,
      !this.#isButtonRow(taskId),
      !(this.#isTotalEstimate(taskId) && (this.#instance.config.multiview || this.#instance.ganttDataApi.isFilterActive() || this.#instance.config.isJira)),
      !this.#instance.config.readonly,
    ];

    if (canShowContextMenu.every(Boolean)) {
      const config = {
        anchorNode,
        anchorPosition: this.#getClickPosition(event),
        taskId,
      };

      this.show(config);
      InlineEditors.hide();
    } else {
      this.hide();
    }

    // actionButtonsModule.handlers.hideColorboard();
  }

  #prepareMenuItems() {
    this.#contextMenuList.clearAll();
    this.#contextMenuList.parse(this.#composeMenuItemsData(this.#contextMenuItemsConfig));

    this.#showAllMenuItems();
    this.#filterMenuItems();

    return this.#contextMenuList.serialize();
  }

  #isTaskRow(target) {
    return _.includes(target.className, 'gantt_task_row');
  }

  #isButtonRow(id) {
    const taskData = this.#instance.getTask(id);

    return taskData && taskData.type === this.#instance.config.types.button;
  }

  #isTotalEstimate(id) {
    const taskData = this.#instance.getTask(id);

    return taskData && taskData.$level === 0;
  }

  #getClickPosition(event) {
    return {
      x: event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft,
      y: event.clientY + document.body.scrollTop + document.documentElement.scrollTop,
    };
  }

  #menuItemClickHandler(item, event, node) {
    switch (item.id) {
    case 'edit_task':
    case 'edit_milestone':
      this.#instance.callEvent('onOpenTaskSettings', [this.#taskId]);

      userExtAnalytics.log('context_menu_click', { line: 'edit task' });
      userExtAnalytics.log('gantt_task_settings_open', {
        from: routerHelper.analyticsFromRoute(),
        route: `${routerHelper.analyticsRoute()}/ContextMenu`,
      });
      break;
    case 'go_to_project':
      this.#instance.callEvent('onOpenTaskProject', [this.#taskId]);
      break;
    case 'add_subtask':
      Tasks.addSubTask(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'add subtask' });
      userExtAnalytics.log('gantt_add_task_grid_done', { type: 'task', way: 'button' });
      break;
    case 'add_sibling_task':
      Tasks.addSiblingTask(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'add sibling task' });
      userExtAnalytics.log('gantt_add_task_grid_done', { type: 'task', way: 'button' });
      break;
    case 'add_sibling_milestone':
      Tasks.addSiblingMilestone(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'add sibling milestone' });
      userExtAnalytics.log('gantt_add_task_grid_done', { type: 'milestone', way: 'button' });
      break;
    case 'move_indent':
      Tasks.moveIndent(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'move indent' });
      break;
    case 'move_outdent':
      Tasks.moveOutdent(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'move outdent' });
      break;
    case 'convert_in_milestone':
    case 'convert_in_task':
      Tasks.convertType(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'convert' });
      userExtAnalytics.log('task_grid_action', { action: 'type' });
      break;
    case 'select_task_for_masschange':
      this.#instance.callEvent('onTaskSelectFromContextMenu', [this.#taskId]);
      break;
    case 'delete_task':
      Tasks.delete(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'delete' });
      userExtAnalytics.log('task_grid_action', { action: 'delete' });
      break;
    case 'copy_task':
      CopyPaste.copy(this.#taskId);

      userExtAnalytics.log('context_menu_click', { line: 'copy' });
      break;
    case 'paste_task_above':
    case 'paste_task_below':
      if (CopyPaste.pasteValidation()) {
        CopyPaste.paste(this.#taskId, item.id);
      }

      userExtAnalytics.log('context_menu_click', { line: 'paste' });
      break;
    case 'copy_paste_settings':
      const task = this.#instance.getTask(this.#taskId);

      this.#instance.ganttDataApi.toggleCopySettingsPopup(true);
      this.#instance.ganttDataApi.setCopyPasteProjectId(task.gantt_id);

      return;
      case 'choose_task_color':
      case 'choose_project_color':
        return true;
    }

    this.hide();
  }

  #setMenuItemTaskColor(taskId) {
    if(!taskId) return;

    const task = this.#instance.getTask(taskId);
    const item = task.$level === 1 && this.#instance.config.multiview ? 'choose_project_color' : 'choose_task_color';

    if (task.color) {
      const colorValue = parseInt(task.color, 10) ? colorHelper.getColorStr(parseInt(task.color, 10)) : task.color;

      this.#contextMenuList.updateItem(item, {
        icon: `<div class='context_menu_list_icon_color' style='background-color: ${colorValue}'></div>`,
      });
    }
  }

  #composeMenuItemsData(config) {
    return config.map(configItem => this.#createMenuItem(configItem));
  }

  #createMenuItem(configItem) {
    const itemValue = (configItem.id !== 'separatorBefore' && configItem.id !== 'separatorAfter' && configItem.id !== 'separatorAfterCopyPaste') ? __(`gantt_${configItem.id}`) : '';
    const menuItem = {
      id: configItem.id,
      icon: configItem.icon,
      disabled: !!configItem.disabled,
      $css: configItem.css,
      handler: this.#menuItemClickHandler.bind(this),
      mouseMoveHandler: configItem.mouseMoveHandler,
      value: itemValue,
      $template: configItem.$template,
    };

    if (configItem.submenu?.length) {
      menuItem.submenu = this.#composeMenuItemsData(configItem.submenu);
    }

    return menuItem;
  }

  #calculatePopupCoordinatesFromNode(node) {
    const coords = node.getBoundingClientRect();

    const docHeight = document.body.clientHeight;
    const docWidth = document.body.clientWidth;
    const popupHeight = this.#contextMenuPopup.$height;
    const popupWidth = this.#contextMenuPopup.$width;

    if ((coords.y + popupHeight + 5) > docHeight) {
      coords.y = Math.max(coords.y - popupHeight - 5, 0);
      coords.x += 30;
    } else {
      coords.y -= 26;
      coords.x += 30;
    }
    if ((coords.x + popupWidth + 24) > docWidth) {
      coords.x -= popupWidth + 50;
    }

    return coords;
  }

  #filterMenuItems() {
    const task = this.#instance.getTask(this.#taskId);

    this.#filterMenuItemsByTaskAndProjectConfig(task);
    this.#filterMenuItemsByRights(task.gantt_id);
  }

  #showAllMenuItems() {
    this.#contextMenuItemsConfig.forEach(item => this.#contextMenuList.showItem(item.id));
  }

  #filterMenuItemsByTaskAndProjectConfig(task) {
    const minLevelForTask = this.#instance.config.multiview ? 2 : 1;

    if (this.#instance.config.multiview && task.$level === 1) {
      const menuItemIds = new Set((this.#contextMenuList.serialize()).map(item => item.id));

      menuItemIds.forEach(id => {
        if (!(id === 'go_to_project' || id === 'choose_project_color')) {
          this.#contextMenuList.hideItem(id);
        }
      });
    } else {
      if (this.#instance.ganttDataApi.isFilterActive()) {
        this.#contextMenuList.hideItem('paste_task');
        this.#contextMenuList.hideItem('copy_task');
        this.#contextMenuList.hideItem('paste_task_disabled');
        this.#contextMenuList.hideItem('copy_paste_settings');
        this.#contextMenuList.hideItem('separatorAfterCopyPaste');

        this.#contextMenuList.hideItem('go_to_project');
        this.#contextMenuList.hideItem('choose_project_color');

        if (task.type === this.#instance.config.types.task) {
          this.#contextMenuList.hideItem('convert_in_task');
          this.#contextMenuList.hideItem('edit_milestone');
        }

        if (task.type === this.#instance.config.types.project) {
          this.#contextMenuList.hideItem('convert_in_task');
          this.#contextMenuList.hideItem('convert_in_milestone');

          if (task.$level < minLevelForTask) {
            this.#contextMenuList.define('yCount', 3);
            this.#contextMenuList.hideItem('add_sibling_task');
            this.#contextMenuList.hideItem('add_sibling_milestone');
            this.#contextMenuList.hideItem('move_outdent');
          }
        } else if (task.$level < minLevelForTask) {
          this.#contextMenuList.hideItem('move_outdent');
        }

        if (task.type === this.#instance.config.types.milestone) {
          this.#contextMenuList.hideItem('convert_in_milestone');
        }

        if (!this.#instance.getPrevSibling(task.id)) {
          this.#contextMenuList.hideItem('move_indent');
          this.#contextMenuList.define('yCount', this.#contextMenuList.config.yCount - 1);
        }

        if (task.$level === 0) {

          const hiddenItems = ['edit_task','edit_milestone', 'add_subtask', 'add_child_milestone', 'select_task_for_masschange', 'paste_task',
            'choose_task_color', 'delete_task', 'paste_task_disabled', 'separatorBefore', 'separatorAfter', 'separatorAfterCopyPaste', 'copy_task'];

          hiddenItems.forEach(name => this.#contextMenuList.hideItem(name));
        }
        this.#contextMenuList.resize();

        return;
      }

      this.#contextMenuList.showItem('add_sibling_task');
      this.#contextMenuList.showItem('copy_task');
      this.#contextMenuList.showItem('add_subtask');
      this.#contextMenuList.showItem('add_sibling_milestone');
      this.#contextMenuList.showItem('add_child_milestone');
      this.#contextMenuList.showItem('move_indent');
      this.#contextMenuList.showItem('move_outdent');

      this.#contextMenuList.hideItem('go_to_project');
      this.#contextMenuList.hideItem('choose_project_color');
      this.#contextMenuList.hideItem('edit_milestone');

      this.#contextMenuList.define('yCount', 6);

      if (this.#instance.config.multiview && task.$level === minLevelForTask) {
        this.#contextMenuList.hideItem('move_outdent');
      }

      if (this.#instance.config.multiview) {
        this.#contextMenuList.hideItem('select_task_for_masschange');
      }

      if (!this.#instance.config.multiview && task.$level <= minLevelForTask) {
        this.#contextMenuList.hideItem('move_outdent');
      }

      const viewData = this.#instance.ganttDataApi.getActiveProjectData();

      if (task.$level === minLevelForTask) {
        if (viewData.is_jira) {
          this.#contextMenuList.hideItem('move_outdent');
        }
      }

      if (task.$level > 12) {
        this.#contextMenuList.hideItem('move_indent');
        this.#contextMenuList.define('yCount', 5);
        this.#contextMenuList.hideItem('add_subtask');
        this.#contextMenuList.hideItem('add_child_milestone');
      }

      if (!this.#instance.getPrevSibling(task.id)) {
        this.#contextMenuList.hideItem('move_indent');
        this.#contextMenuList.define('yCount', this.#contextMenuList.config.yCount - 1);
      }

      if (task.type === this.#instance.config.types.task) {
        this.#contextMenuList.hideItem('convert_in_task');
      }

      if (task.type === this.#instance.config.types.project) {
        this.#contextMenuList.hideItem('convert_in_task');
        this.#contextMenuList.hideItem('convert_in_milestone');

        if (task.$level < minLevelForTask) {
          this.#contextMenuList.define('yCount', 3);
          this.#contextMenuList.hideItem('add_sibling_task');
          this.#contextMenuList.hideItem('add_sibling_milestone');
          this.#contextMenuList.hideItem('move_outdent');
        }
      } else if (task.$level < minLevelForTask) {
        this.#contextMenuList.hideItem('move_outdent');
      }

      if (task.type === this.#instance.config.types.milestone) {
        this.#contextMenuList.hideItem('edit_task');
        this.#contextMenuList.hideItem('add_subtask');
        this.#contextMenuList.hideItem('add_child_milestone');
        this.#contextMenuList.hideItem('convert_in_milestone');
        this.#contextMenuList.showItem('edit_milestone');
        this.#contextMenuList.define('yCount', 3);

        if (task.$level === 0 || task.$level === 1) {
          this.#contextMenuList.define('yCount', 2);
          this.#contextMenuList.hideItem('move_outdent');
        }
      }

      if (this.#contextMenuList.getItem('paste_task') && this.#contextMenuList.getItem('paste_task_disabled')) {
        if (this.#instance.ganttDataApi.hasCopiedTask()) {
          this.#contextMenuList.hideItem('paste_task_disabled');
          this.#contextMenuList.showItem('paste_task');
        } else {
          this.#contextMenuList.showItem('paste_task_disabled');
          this.#contextMenuList.disableItem('paste_task_disabled');
          this.#contextMenuList.hideItem('paste_task');
        }
      }

      if (viewData.is_jira) {
        this.#contextMenuList.hideItem('edit_milestone');
        this.#contextMenuList.hideItem('copy_task');
        this.#contextMenuList.hideItem('paste_task');
        this.#contextMenuList.hideItem('paste_task_disabled');
        this.#contextMenuList.hideItem('copy_paste_settings');
        this.#contextMenuList.hideItem('select_task_for_masschange');
        this.#contextMenuList.hideItem('separatorAfterCopyPaste');
        if (task.$level === 1 && (this.#instance.config.gantt_id <= GT.lastProjectIdBeforeRootTask)) this.#contextMenuList.hideItem('delete_task');
      }

      this.#contextMenuList.resize();
    }

    if (task.$level === 0) {
      this.#contextMenuList.showItem('copy_task');

      const hidenItems = ['edit_task','edit_milestone', 'add_subtask', 'add_child_milestone', 'select_task_for_masschange', 'paste_task',
        'choose_task_color', 'delete_task', 'paste_task_disabled', 'separatorBefore', 'separatorAfter', 'separatorAfterCopyPaste'];

      this.#instance.config.isJira && hidenItems.push('copy_task');

      hidenItems.forEach(name => this.#contextMenuList.hideItem(name));
    }
  }

  #filterMenuItemsByRights(projectId) {
    const blockItems = getBlockedItemsByRights(this.#instance, projectId);

    if (blockItems.length) {
      const menuItems = this.#contextMenuList.serialize();
      let visibleCount = 0;

      menuItems.forEach(item => {
        if (blockItems.includes(item.id)) {
          this.#contextMenuList.hideItem(item.id);
        } else {
          visibleCount++;
        }
      });

      if (visibleCount === 2) {
        this.#contextMenuList.hideItem('separatorAfter');
        this.#contextMenuList.hideItem('separatorAfterCopyPaste');
      }
    }
  }

  #showColorBoard(node, position) {
    if (!position || _.isEmpty(position)) {
      position = {
        pos: 'right',
        x: -6, // 170
        y: 3,
      };
    }

    this.#selectColorOnColorBoard();
    $$(innerViews.taskColorPopup.id).show(node, position);
    userExtAnalytics.log('context_menu_click', { line: 'color' });
  }

  #hideColorBoard() {
    $$(innerViews.taskColorPopup.id).hide();
  }

  #attachColorBoardEvents() {
    $$('gridColorboard').attachEvent('onSelect', colorHex => this.#onColorBoardSelect(colorHex));
  }

  #onColorBoardSelect(colorHex) {
    if(!this.#taskId) return;
    const task = this.#instance && this.#instance.getTask(this.#taskId);
    task.color = colorHelper.getColorId(colorHex);
    this.#instance.updateTask(this.#taskId);
    this.#hideColorBoard();
    this.#setMenuItemTaskColor(this.#taskId);

    this.hide();
    userExtAnalytics.log('task_grid_action', { action: 'color' });
  }

  #selectColorOnColorBoard() {
    if(!this.#taskId) return;
    const task = this.#instance && this.#instance.getTask(this.#taskId);
    const $$taskColorBoard = $$(innerViews.taskColorBoard.id);
    let colorValue;

    $$taskColorBoard.blockEvent();

    if (task?.color) {
      colorValue = parseInt(task.color, 10) ? colorHelper.getColorStr(parseInt(task.color, 10)) : task.color;

      $$taskColorBoard.setValue(colorValue);
    }

    $$taskColorBoard.unblockEvent();
  }
}

const innerTemplates = {
  menuItem(item) {
    if (item.id !== 'separatorBefore' && item.id !== 'separatorAfter' && item.id !== 'separatorAfterCopyPaste') {
      return `<div class='context_menu_list_item_icon'>${item.icon}</div>`
        + `<div class='context_menu_list_item_text'>${item.value}</div>`;
    }
  },
};

const innerViews = {
  taskColorPopup: {
    id: 'gridColorboardPopup',
  },
  main: {
    id: 'contextMenu',
  },
  contextMenuList: {
    id: 'contextMenuList',
    view: 'menu',
    css: 'context_menu_list',
    borderless: true,
    autoheight: true,
    subMenuPos: 'right',
    layout: 'y',
    data: [],
    type: {
      height: 32,
    },
    template: innerTemplates.menuItem,
    submenuConfig: {
      width: 200,
      // id: 'context_menu_submenu',
      view: 'contextMenuSubmenu',
      borderless: true,
      padding: 0,
      type: {
        height: 32,
      },
      css: 'context_menu_submenu',
      template: innerTemplates.menuItem,
      on: {
        onBeforeShow() {
          app.trigger('context_menu:mouse:move');
        },
        onItemClick(id, event, node) {
          const item = this.getItem(id);

          item.handler && item.handler(item, event, node);
        },
      },
    },
    on: {
      onItemClick(id, event, node) {
        const item = this.getItem(id);

        item.handler && item.handler(item, event, node);

        item.mouseMoveHandler && item.mouseMoveHandler(node);
      },
      onMouseMove(id, e, node) {
        const item = this.getItem(id);

        if (!_.includes(['choose_task_color', 'paste_task'], id)) {
          $$(innerViews.taskColorPopup.id).hide();
        }

        item && item.mouseMoveHandler && item.mouseMoveHandler(node);
      },
    },
  },
  taskColorBoard: {
    view: 'colorboardCst',
    id: 'gridColorboard',
    css: 'task-settings-color-board',
    width: 180,
    height: 120,
    palette: constants.PALETTE_CONFIG.palette.map(item => item.map(cell => cell.color)),
    template(obj) {
      return `<div class="color-bar" style="background: ${obj.val};"><div class="color-bar-inside-border"></div></div>`;
    },
  },
};

function loadWebixTemplates() {
  // exclude webix templates from public url app

  webix.ui({
    view: 'popupWithoutPoint',
    css: 'grid-colorboard-popup',
    id: innerViews.taskColorPopup.id,
    padding: 8,
    hidden: true,
    body: innerViews.taskColorBoard,
  });

  webix.ui({
    id: innerViews.main.id,
    view: 'popupWithoutPoint',
    css: 'context_menu_popup',
    hidden: true,
    borderless: true,
    autoheight: true,
    width: getWidthForMenu(),
    body: {
      rows: [
        innerViews.contextMenuList,
      ],
    },
    on: {
      onHide() {
        // this.#instance.setBlockingCollaborationByPopup(innerViews.contextMenuList.id, false);
        app.trigger('gantt:contextMenu:hidden');
        const nodes = document.querySelectorAll('.column-options-cog');

        _.each(nodes, node => {
          node && node.classList.remove('active');
        });
      },
    },
  });
}

function getWidthForMenu() {
  if (user.locale === 'de') {
    return 344;
  }

  if (user.locale === 'pt' || user.locale === 'es') {
    return 266;
  }

  return 236;
}

export default new WebixContextMenu();
